import "./lostPasswordRequestMailPage.scss"
import { querySelectorNonNull } from "../../document"
import { onAllPreloadScriptsLoaded } from "../../utils"
import { AuthField, validateAuthFieldWith } from "../../fragments/authField/authField"
import { validateCurrentEmail } from "../../fragments/emailInputField/currentEmailValidator"
import { appendSpinnerToFormButtons } from "../../spinner"
import { FormStorage } from "../../session/form-storage"
import { setBlockedTimer } from "../../timer"
import CallbackButton from "../../fragments/callback/callback"

export class LostPasswordRequestMailPage {
    private readonly emailInputField: AuthField
    private readonly formStorage: FormStorage
    private readonly documentObject: Document

    constructor(document: Document) {
        const emailInputField: HTMLOcAuthFieldV1Element = querySelectorNonNull(document, ".fti-ci-js-email-field")
        this.emailInputField = new AuthField(emailInputField)
        this.formStorage = new FormStorage(document, "fti-ci-requestLostPasswordMail-form")
        new CallbackButton(document)
        this.documentObject = document
        setBlockedTimer(document)
    }

    async init() {
        appendSpinnerToFormButtons(this.documentObject, ".fti-ci-js-lostPassword-requestMail-form")
        validateAuthFieldWith(this.emailInputField, validateCurrentEmail)
        await this.formStorage.setFormValues()
    }
}

onAllPreloadScriptsLoaded(async () => {
    await new LostPasswordRequestMailPage(document).init()
})
